export default [
  { title: "About Us", link: "/aboutus" },
  { title: "Chairman's Message", link: "/chairman" },
  { title: "Principal's Message", link: "/principal-message" },
  { title: "Our Story", link: "/OurStory" },
  { title: "Infrastructure", link: "/infrastructure" },
  { title: "Curriculum", link: "/curriculum" },
]
